/* global FB:false */
import angular from 'angular';
import { merge } from 'lodash';

module.exports = angular.module('market.services.facebook', [])
.factory('Facebook', function(FacebookAppId, $q) {
  window.fbAsyncInit = function() {
    FB.init({
      appId: FacebookAppId,
      xfbml: true,
      version: 'v2.5'
    });
  };

  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "//connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));

  return {
    // Available sharing options:
    // {
    //   href
    //   title (html page title)
    //   description
    //   picture (url)
    //   caption (short url)
    // }
    share(sharingOptions) {
      let deferred = $q.defer();
      FB.ui(merge({ method: 'share' }, sharingOptions),
            (response) => deferred.resolve(response));
      return deferred.promise;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/services/facebook.js
 **/